<template>
  <div id="app">
   <router-view v-if="isRouterAlive">

   </router-view>
  </div>
</template>

<script>

export default {
  data () {
    return {
      isRouterAlive: true // 控制视图是否显示的变量
    }
  },
  // created(){
  //   let docEle = document.documentElement
  //   let clientWidth = docEle.clientWidth;
  //   docEle.style.fontSize =  clientWidth/10+'px'
  // },
  provide () { // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },

  methods: {
    reload () {
      this.isRouterAlive = false // 先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true // 再打开
      })
    }

  },
  name: 'App'
}
</script>

<style>
	@import url("./assets/css/font.css");
	body{
		color:#333;
	}

#app {

  font-family: 'Avenir', Helvetica, Arial, sans-serif;
	/* font-family:"simhei"; */
/* 	font-family: "黑体",sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
}

</style>



// WEBPACK FOOTER //
// src/App.vue